interface Row {
    [key: string]: string;
}

export class HelpUtil {
    static formatDate(dateString: any) {
        const date = new Date(dateString);
        const day = date.getDate();
        const year = date.getFullYear();
        const month = new Intl.DateTimeFormat('en', {month: 'long'}).format(date);
        const ordinalSuffix = (n: any) => ['th', 'st', 'nd', 'rd'][(n % 100 - 20) % 10] || 'th';
        // Format the date with the ordinal suffix
        return `${day}${ordinalSuffix(day)} ${month} ${year}`;
    }

    static parseCSV(csvText: any) {
        const lines = csvText.split('\n');
        const headers = lines[0].split(',').map((header: string) => header.trim());
        const data = [];

        for (let i = 1; i < lines.length; i++) {
            const values = lines[i].split(',');
            if (values.length === headers.length) {
                const row: Row = {};
                for (let j: number = 0; j < headers.length; j++) {
                    row[headers[j]] = values[j].trim();
                }
                data.push(row);
            }
        }

        return data;
    }

}

